<div class="grid grid-cols-1 md:grid-cols-3 gap-8 p-4 sm:p-8">
    <mat-card class="flex flex-col">
        <mat-card-header>
            <mat-card-title class="flex items-center flex-wrap gap-2">
                <ng-container *ngIf="userUiType !== 4; else ambassadorCardTitle">Card Image</ng-container>
                <ng-template #ambassadorCardTitle>Profile Picture</ng-template>
                <span *ngIf="isMissingImage(destination.im_mediacard)" class="bg-red-500 text-white px-2 py-0.5 rounded text-xs font-bold animate-pulse shadow-sm">
                    ⚠️ Missing Critical Data
                </span>
            </mat-card-title>
        </mat-card-header>
        <div class="flex-grow flex items-center justify-center bg-gray-50 dark:bg-gray-800 p-4">
            <img [src]="destination.im_mediacard || 'assets/images/apps/ecommerce/ar-logo-no-slogan-1.png'"
                 alt="Card Placeholder"
                 class="h-40 object-contain max-w-full">
        </div>
        <mat-card-content class="pt-4">
            <p class="text-sm text-gray-600">
                <ng-container *ngIf="userUiType !== 4; else ambassadorCardDesc">Used in search results and promotional carousels.</ng-container>
                <ng-template #ambassadorCardDesc>This is your avatar, used across the site in comments, recommendations, and search results.</ng-template>
            </p>
        </mat-card-content>
        <mat-card-actions class="!p-4 mt-auto">
            <div class="w-full flex items-center space-x-2">
                <button mat-flat-button color="primary" class="flex-auto"
                        (click)="onFileInputClick('ImageCardFileInput')">
                    <ng-container *ngIf="userUiType !== 4; else ambassadorChangeCardBtn">Change Photo</ng-container>
                    <ng-template #ambassadorChangeCardBtn>Change Picture</ng-template>
                </button>
                <button mat-stroked-button (click)="openInNewTab(destination.im_mediacard)">
                    <mat-icon>open_in_new</mat-icon>
                </button>
            </div>
            <input hidden type="file" id="ImageCardFileInput" (change)="handleFileUpload($event, 'card')" accept="image/*"/>
        </mat-card-actions>
    </mat-card>

    <mat-card class="flex flex-col">
        <mat-card-header>
            <mat-card-title class="flex items-center flex-wrap gap-2">
                <ng-container *ngIf="userUiType !== 4; else ambassadorBannerTitle">Banner Image</ng-container>
                <ng-template #ambassadorBannerTitle>Profile Banner</ng-template>
                <span *ngIf="isMissingImage(destination.im_media)" class="bg-red-500 text-white px-2 py-0.5 rounded text-xs font-bold animate-pulse shadow-sm">
                    ⚠️ Missing Critical Data
                </span>
            </mat-card-title>
        </mat-card-header>
        <div class="flex-grow relative bg-gray-50 dark:bg-gray-800">
            <img [src]="destination.im_media || 'assets/images/apps/ecommerce/ar-logo-no-slogan-1.png'"
                 alt="Banner Placeholder"
                 class="w-full h-48 object-contain max-w-full">
        </div>
        <mat-card-content class="pt-4">
            <p class="text-sm text-gray-600">
                <ng-container *ngIf="userUiType !== 4; else ambassadorBannerDesc">This is the main image displayed on the destination's profile page.</ng-container>
                <ng-template #ambassadorBannerDesc>This is the main banner displayed at the top of your public profile page.</ng-template>
            </p>
            <p *ngIf="destination.im_mediavideo && isVideoUrl(destination.im_mediavideo)" class="text-sm text-amber-600 mt-2 font-semibold">
                <ng-container *ngIf="userUiType !== 4; else ambassadorVideoActive">A video is active and will be shown instead of this image.</ng-container>
                <ng-template #ambassadorVideoActive>Your introductory video is active and will be shown instead of this banner.</ng-template>
            </p>
        </mat-card-content>
        <mat-card-actions class="!p-4 mt-auto">
            <div class="w-full flex items-center space-x-2">
                <button mat-flat-button color="primary" class="flex-auto"
                        (click)="onFileInputClick('MainImageFileInput')">
                    <ng-container *ngIf="userUiType !== 4; else ambassadorChangeBannerBtn">Change Photo</ng-container>
                    <ng-template #ambassadorChangeBannerBtn>Change Banner</ng-template>
                </button>
                <button mat-stroked-button (click)="openInNewTab(destination.im_media)">
                    <mat-icon>open_in_new</mat-icon>
                </button>
            </div>
            <input hidden type="file" id="MainImageFileInput" (change)="handleFileUpload($event, 'main')" accept="image/*"/>
        </mat-card-actions>
    </mat-card>

    <mat-card class="flex flex-col">
        <mat-card-header>
            <mat-card-title>
                <ng-container *ngIf="userUiType !== 4; else ambassadorVideoTitle">Main Video</ng-container>
                <ng-template #ambassadorVideoTitle>Introductory Video</ng-template>
            </mat-card-title>
        </mat-card-header>
        <div class="flex-grow bg-gray-50 dark:bg-gray-800">
            <ng-container *ngIf="isVideoUrl(destination.im_mediavideo); else videoPlaceholder">
                <video [src]="destination.im_mediavideo" muted controls class="w-full h-48 bg-black"></video>
            </ng-container>
            <ng-template #videoPlaceholder>
                <div class="h-48 flex items-center justify-center">
                    <mat-icon class="!w-16 !h-16 text-gray-400" svgIcon="heroicons_outline:video-camera-slash"></mat-icon>
                </div>
            </ng-template>
        </div>
        <mat-card-content class="pt-4">
            <p class="text-sm text-gray-600">
                <ng-container *ngIf="userUiType !== 4; else ambassadorVideoDesc">Uploading a video will replace the main banner image.</ng-container>
                <ng-template #ambassadorVideoDesc>Introduce yourself! A short video will replace your profile banner.</ng-template>
            </p>
        </mat-card-content>
        <mat-card-actions class="!p-4 mt-auto">
            <div class="w-full flex items-center space-x-2">
                <button mat-flat-button color="primary" class="flex-auto" (click)="onFileInputClick('MainVideoFileInput')">
                    {{ isVideoUrl(destination.im_mediavideo) ? 'Change Video' : 'Upload Video' }}
                </button>
                <button *ngIf="isVideoUrl(destination.im_mediavideo)" mat-stroked-button color="warn" (click)="deleteVideo()">
                    Delete
                </button>
            </div>
            <input hidden type="file" id="MainVideoFileInput" (change)="handleFileUpload($event, 'video')" accept="video/*"/>
        </mat-card-actions>
    </mat-card>
</div>
